import * as React from 'react'

import * as Style from './style.css'

export interface IProps {
  pageTitle: string
  previousUrl: string
}

export const MobileMenu = ({ pageTitle, previousUrl }: IProps): JSX.Element => {
  return (
    <div className={Style.MobileMenu}>
      <a href={previousUrl} className={Style.MobileMenuPrevious}>
        &lt; 戻る
      </a>
      <div className={Style.MobileMenuCurrent}>{pageTitle}</div>
    </div>
  )
}
